import { Check } from 'lucide-react';
import { formatFileSize } from '../../../utils/format';

// additionalDetails keys that are bookkeeping, not buyer information (e.g. "seed": "dev-demo").
const INTERNAL_DETAIL_KEY = /^(seed|demo[-_ ]?seed|internal|test|_.*)$/i;

const detailRows = product => {
  const rows = Object.entries(product.additionalDetails || {})
    .filter(
      ([key, value]) =>
        key?.trim() &&
        !INTERNAL_DETAIL_KEY.test(key.trim()) &&
        value !== null &&
        value !== undefined &&
        String(value).trim()
    )
    .map(([key, value]) => [key.trim(), String(value).trim()]);

  const digital = product.digitalProductDetails || {};
  if (digital.edition?.trim()) rows.push(['Edition', digital.edition.trim()]);
  const size = formatFileSize(digital.estimatedDownloadSizeMB);
  if (size) rows.push(['Download size', size]);

  return rows;
};

const clean = list => (Array.isArray(list) ? list : []).map(v => String(v ?? '').trim()).filter(Boolean);

/** Left column: about, features, what's included, tech stack and details. */
const ProductDescriptionSection = ({ product, about }) => {
  const features = clean(product.features);
  const included = clean(product.whatInsideTheBox);
  const technologies = clean(product.technologies);
  const details = detailRows(product);

  return (
    <>
      {about && (
        <section className="pd-section" aria-labelledby="pd-about-title">
          <h2 id="pd-about-title" className="pd-section__title">
            About this project
          </h2>
          <p className="pd-about">{about}</p>
        </section>
      )}

      {features.length > 0 && (
        <section className="pd-section" aria-labelledby="pd-features-title">
          <h2 id="pd-features-title" className="pd-section__title">
            Features
          </h2>
          <ul className="pd-features">
            {features.map((feature, i) => (
              <li key={`${feature}-${i}`}>{feature}</li>
            ))}
          </ul>
        </section>
      )}

      {included.length > 0 && (
        <section className="pd-section" aria-labelledby="pd-included-title">
          <h2 id="pd-included-title" className="pd-section__title">
            What&apos;s included
          </h2>
          <ul className="pd-checks">
            {included.map((item, i) => (
              <li key={`${item}-${i}`}>
                <Check aria-hidden="true" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </section>
      )}

      {technologies.length > 0 && (
        <section className="pd-section" aria-labelledby="pd-tech-title">
          <h2 id="pd-tech-title" className="pd-section__title">
            Tech stack
          </h2>
          <ul className="pd-tags">
            {technologies.map((tech, i) => (
              <li key={`${tech}-${i}`} className="pd-tag">
                {tech}
              </li>
            ))}
          </ul>
        </section>
      )}

      {details.length > 0 && (
        <section className="pd-section" aria-labelledby="pd-details-title">
          <h2 id="pd-details-title" className="pd-section__title">
            Details
          </h2>
          <dl className="pk-rows pd-details">
            {details.map(([key, value]) => (
              <div key={key}>
                <dt>{key}</dt>
                <dd>{value}</dd>
              </div>
            ))}
          </dl>
        </section>
      )}
    </>
  );
};

export default ProductDescriptionSection;
